module.exports = __webpack_public_path__ + "img/NP.0fabf24d.svg";